import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, Lock, Eye, EyeOff } from 'lucide-react';
import Button from './components/Button';

import { devLog } from '../../../utils/devLog';
const Login = () => {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [formData, setFormData] = useState({
        email: '',
        password: '',
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        devLog('Login form submitted:', formData);
    };

    return (
        <div className="w-full min-h-screen bg-[#F0F7FA] flex items-center justify-center px-4 py-12" style={{ fontFamily: "'Work Sans', sans-serif" }}>
            <link href="https://fonts.googleapis.com/css2?family=Work+Sans:wght@300;400;500;600;700&display=swap" rel="stylesheet" />

            <div className="w-full max-w-md">
                {/* Brand */}
                <div className="text-center mb-8">
                    <h1
                        className="text-2xl font-bold tracking-wider text-[#1B4965] cursor-pointer mb-2"
                        onClick={() => navigate('/template4')}
                    >
                        NEELA
                    </h1>
                    <p className="text-sm text-[#6B7280]">Welcome back! Sign in to your account</p>
                </div>

                {/* Form Card */}
                <div className="bg-white p-6 sm:p-8 rounded-sm border border-[#E5E7EB] shadow-sm">
                    <form onSubmit={handleSubmit} className="space-y-5">
                        {/* Email */}
                        <div>
                            <label className="block text-xs font-medium text-[#6B7280] mb-1.5">Email Address</label>
                            <div className="relative">
                                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#6B7280]" />
                                <input
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    placeholder="you@email.com"
                                    className="w-full pl-10 pr-4 py-2.5 text-sm border border-[#E5E7EB] rounded-sm focus:outline-none focus:border-[#1B4965] text-[#1A1A1A]"
                                    required
                                />
                            </div>
                        </div>

                        {/* Password */}
                        <div>
                            <label className="block text-xs font-medium text-[#6B7280] mb-1.5">Password</label>
                            <div className="relative">
                                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#6B7280]" />
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    name="password"
                                    value={formData.password}
                                    onChange={handleInputChange}
                                    placeholder="Enter your password"
                                    className="w-full pl-10 pr-10 py-2.5 text-sm border border-[#E5E7EB] rounded-sm focus:outline-none focus:border-[#1B4965] text-[#1A1A1A]"
                                    required
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPassword(!showPassword)}
                                    className="absolute right-3 top-1/2 -translate-y-1/2 text-[#6B7280] hover:text-[#1B4965]"
                                >
                                    {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                                </button>
                            </div>
                        </div>

                        {/* Forgot Password */}
                        <div className="text-right">
                            <button type="button" className="text-xs text-[#1B4965] hover:text-[#133B53] font-medium bg-transparent border-none cursor-pointer">
                                Forgot password?
                            </button>
                        </div>

                        <Button type="submit" variant="primary" size="lg" fullWidth>
                            Sign In
                        </Button>
                    </form>

                    <div className="mt-6 text-center">
                        <p className="text-sm text-[#6B7280]">
                            Don't have an account?{' '}
                            <button
                                onClick={() => navigate('/template4/signup')}
                                className="text-[#1B4965] hover:text-[#133B53] font-semibold bg-transparent border-none cursor-pointer"
                            >
                                Sign Up
                            </button>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
